module.exports = __webpack_public_path__ + "static/media/eyeLooking.16ef3ff0.svg";